import { uapi } from "@/utils/api";
import load from "@virgodev/bazaar/functions/localstorage/get";
import save from "@virgodev/bazaar/functions/localstorage/put";

import { defineStore } from "pinia";
import { ref, type Ref } from "vue";
import { useSSRStore } from "./ssr";

export interface SnippetSection {
  name: string;
}

export interface Snippet {
  section: SnippetSection;
  content: string;
}

export interface Page {
  title: string;
  content: string;
  keywords: string;
  description: string;
}

export const useContentStore = defineStore("content", () => {
  const pages: Ref<{ [key: string]: Page }> = ref(load("content:pages") || {});
  const pagesUpdated = ref(load("content:pagesUpdated") || 0);
  const snippets: Ref<Snippet[]> = ref(load("content:snippets") || []);
  const snippetsUpdated = ref(load("content:snippetsUpdated") || 0);
  const ssr = useSSRStore();

  async function fetchSnippets() {
    let response = await uapi({ url: "snippets/" });
    snippets.value = response.body;
    save("content:snippets", snippets.value);
    save("content:snippetsUpdated", snippetsUpdated.value);
  }
  async function fetchPages(filters = {}) {
    let response = await uapi({ url: "pages/", params: filters });
    const retval: { [key: string]: any } = {};
    for (const row of response.body) {
      retval[row.url] = row;
    }
    pages.value = retval;
    save("content:pages", pages.value);
    save("content:pagesUpdated", pagesUpdated.value);
  }

  async function update(force = false) {
    if (
      force ||
      !pagesUpdated.value ||
      pagesUpdated.value < Date.now() - 1000 * 60 * 60 * 4 ||
      Object.keys(pages.value).length === 0
    ) {
      await fetchPages();
    }
    if (
      force ||
      !snippetsUpdated.value ||
      snippetsUpdated.value < Date.now() - 1000 * 60 * 60 * 4 ||
      snippets.value.length === 0
    ) {
      await fetchSnippets();
    }
    ssr.provides("content");
  }

  return { pages, snippets, update };
});
